import { UnixRangePicker } from '../components'
import { dateRangeSchema } from '../schemas'
import { withFormItem } from './form-item'

export const DateRangeRenderer = withFormItem(dateRangeSchema)(childrenProps => {
  return <UnixRangePicker {...childrenProps} />
})
